module.exports = __webpack_public_path__ + "img/iconlogin.e4c3b79d.png";